import { ReactElement } from 'react'

import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons'
import { Input } from 'antd'
import classNames from 'classnames'
import { getIn } from 'formik'

import { BRAND_COLOR } from 'const/colors'

import { FormikWithCustomHandlersProps } from '../propTypes'
import withCustomHandlers from '../withCustomHandlers'

type FormikInputProps<V> = FormikWithCustomHandlersProps<V>

function FormikInput<V extends string[]>({
    field: { value, name },
    form,
    handleChange,
    handleBlur,
    handleClick,
    ...props
}: FormikInputProps<V>): ReactElement {
    return (
        <Input.Password
            iconRender={(visible) =>
                visible ? (
                    <EyeTwoTone twoToneColor={BRAND_COLOR.PRIMARY} />
                ) : (
                    <EyeInvisibleOutlined />
                )
            }
            value={value}
            type="password"
            onChange={(e) => handleChange(e.target.value)}
            onBlur={handleBlur}
            className={classNames({
                'fg-control-error':
                    getIn(form.errors, name) && getIn(form.touched, name),
            })}
            {...props}
        />
    )
}

export default withCustomHandlers(FormikInput)
